import { schema } from "normalizr";

const CompanySchema = new schema.Entity("companies");
const CompanyArraySchema = new schema.Array(CompanySchema);

export { CompanySchema, CompanyArraySchema };